/**
 * Unified Consent Type enum
 * Used for tracking DSR consent events in Mixpanel
 */
export enum UnifiedConsentType {
  ONLY_CONSENT = 'only_consent',
  CONSENT_WITH_EMAIL = 'consent_with_email',
  CONSENT_FROM_CHAT = 'consent_from_chat',
}
